<!--

    Copyright © Siemens 2026

-->
<ix-dropdown-item label="Sign Out" icon="log-out" (click)="openModal()"></ix-dropdown-item>
<ng-template #customModal let-modal>
<ix-modal>
    <ix-modal-header>Signing out of Publisher UI</ix-modal-header>
    <ix-modal-content
    >Are you sure you want to sign out?</ix-modal-content
    >
    <ix-modal-footer>
    <ix-button
        outline
        class="dismiss-modal"
        (click)="modal.dismiss('dismiss')"
    >
        Cancel
    </ix-button>
    <ix-button class="close-modal" (click)="modal.close('okay')">
        Sign Out
    </ix-button>
    </ix-modal-footer>
</ix-modal>
</ng-template>